import React from "react"

import Index from "../components/pages/mentors.js"

const IndexPage = () => (
  <Index lang="pl" />
)

export default IndexPage
